<template>
  <div class="white">
    <b-row>
      <b-col cols="12">
        <b-form-group label="Busqueda">
          <b-row>
            <b-col cols="9">
              <b-input-group>
                <b-input-group-prepend>
                  <b-btn @click="solicitudProviderLocal(1)"><b-icon icon="arrow-clockwise"></b-icon></b-btn>
                </b-input-group-prepend>
                <b-form-input :disabled="disabled"
                  v-model="filtroSearch.text"
                  :placeholder="filtroTipoBusqueda.selected"
                  @change="solicitudProviderLocal(1)"  />
                <b-input-group-append>
                  <b-button text="Button" variant="primary"><b-icon icon="search"></b-icon></b-button>
                </b-input-group-append>
              </b-input-group>
              <!-- <b-form-input v-model="filtroSearch.text" @change="solicitudProviderLocal(1)" :placeholder="filtroTipoBusqueda.selected"/> -->
            </b-col>
            <b-col cols="3">
                <b-form-select
                  :disabled="disabled"
                  value-field="text"
                  v-model="filtroTipoBusqueda.selected"
                  :options="filtroTipoBusqueda.opciones"
                  @change="solicitudProviderLocal(1)">
                </b-form-select>
            </b-col>
          </b-row>
        </b-form-group>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import multiselect from "vue-multiselect";
import { mapGetters, mapActions } from "vuex";
import { createHelpers } from 'vuex-map-fields';

const { mapFields } = createHelpers({
  getterType: 'SolicitudAltaModule/getSolicitudAltaField'
});


export default {
  name: "FiltroSolicitudAltaMedica",
  props: {
  },
  watch: {
  },
  components: {
    multiselect,
  },
  computed: {
    ...mapGetters(["getEstablecimiento" ,'isInRoleAdmin', 'isInRoleCoordinador',]),
    ...mapFields({
      filtroEstado: 'filtro.estado',
      filtroTipo: 'filtro.tipo',
      filtroDestino: 'filtro.destino',
      listaSolicitudes: 'tabla',
      filtroEstablecimiento: 'filtro.establecimiento',
      filtroTipoBusqueda: 'filtro.search.tipoBusqueda',
      filtroSearch: 'filtro.search',
      filtroPresentacion: 'filtro.presentacion',
      filtroSortBy: 'filtro.sortBy',
      filtroOrderBy: 'filtro.orderBy',
    }),
  },
  data() {
    return {
      opciones: [],
      filter: "",
      disabled: false,
      listacolegios: []
    };
  },
  methods: {
    ...mapActions("NivelModule", ["getLista", "getEstablecimientos"]),
    ...mapActions("SolicitudAltaModule",["solicitudProvider"]),
    solicitudProviderLocal(resetPagination) {
      this.disabled = true;
      console.log('resetPagination', resetPagination);
      this.solicitudProvider(resetPagination).then(r => {
        console.log('solicitudprovider then', r);

        this.disabled = false;
      });
    },
    getSelectEstablecimientos(){
      console.log('getSelectEstablecimientos');
      this.getEstablecimientos()
        .then((r) => {
          console.log('getSelectEstablecimientos then', r);
          if(this.getEstablecimiento.NivelEnseñanza_Id === null){
            if(this.getEstablecimiento.UnidadEducativa_Id === null){
              this.listacolegios.push({ value: -1, text: '-SAED-' });
            }
            this.listacolegios.push({ value: 0, text: '--Todos--' });
            r.data.rows.forEach((element) => {
              this.listacolegios.push({ value: element.Id, text: element.DisplayUnidadEducativaNivelSinCuise });
            });
            this.filtroDestino.opciones = this.listacolegios.sort((a, b) => a.text > b.text ? 1 : -1);
          }
        })
        .catch((e) => {
          console.log(e);
        });
    },
  },
  mounted () {
  },
  created() {
    //this.loadSiteKey();
    this.getSelectEstablecimientos();
  },
};
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/common/FiltroSolicitudAltaMedica.vue